import { getCurrencies } from '@/api/config/getCurrencies.ts';
import { webapi } from '@/api/webapi.ts';

export const configApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    currencies: getCurrencies(builder),
  }),
});

export const { useCurrenciesQuery } = configApi;
